<template lang="pug">
  el-container(id="PrivilegeList-container")
    el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll
      el-header(id="PrivilegeList-header" height='40px') {{$t('Privileges list')}}
        el-tooltip(
          effect="light",
          :content="$t('Add new privileges')",
          placement="left",
          :transition="uxParam('tooltipTransition')",
          :open-delay="uxParam('tooltipActivationDelay')"
        )
          el-button.el-button--mini.float-right(
            id="PrivilegeList-addPrivilegeButton",
            type='success',
            icon='el-icon-plus',
            :circle="uxParam('buttonCircle')",
            :round="uxParam('buttonRound')",
            :plain="uxParam('buttonPlain')",
            @click="handleAdd()"
          )
      .row.header
        .cell.method.header
          .name {{ $t('Method') }}
          el-input.input(id="PrivilegeList-methodSearch" v-model='methodSearch', size='mini', type='text', clearable)
        .cell.entity.header
          .name {{ $t('Entity') }}
          el-input.input(id="PrivilegeList-entitySearch" v-model='entitySearch', size='mini', type='text', clearable)
        .cell.action.header
          .name {{ $t('Action') }}
          el-input.input(id="PrivilegeList-actionSearch" v-model='actionSearch', size='mini', type='text', clearable)
        .cell.description.header
          .name {{ $t('Description') }}
          el-input.input(id="PrivilegeList-descriptionSearch" v-model='descriptionSearch', size='mini', type='text', clearable)
        .cell.roles.header
          .name {{ $t('Roles') }}
          el-input.input(id="PrivilegeList-roleSearch" v-model='roleSearch', size='mini', type='text', clearable)
        .cell.buttons.header {{ $t('') }}
      .row(v-for="privilege of privileges", :key='privilege.id', :id="'PrivilegeList-listRow' + privilege.id")
        .cell.method {{ privilege.method}}
        .cell.entity {{ privilege.entity}}
        .cell.action {{ privilege.action}}
        .cell.description {{ privilege.description}}
        .cell.roles
          .row-inner(v-for="role of privilege.Roles", :key='role.id')
            .pre {{ role.name }}
        .cell.buttons
          el-button-group
            el-button(
              :id="'PrivilegeList-editPrivilege' + privilege.id + 'Button'",
              type="success",
              @click="handleEdit(privilege)",
              :title="$t('Edit privilege')",
              size="mini"
            )
              font-awesome-icon.float-right.button(icon="edit")
    PrivilegeEdit(:privilegeId="editedPrivilegeId", :editDialogVisible="editDialogVisible", @closeEditDialog="handleCloseEditDialog()")
</template>

<script>
import PrivilegeEdit from './PrivilegeEdit'

export default {
  props: ['side'],
  components: { PrivilegeEdit },
  created () {
    this.$store.dispatch('Privilege/getData')
  },
  data () {
    return {
      checked: [],
      multipleSelection: [],
      editDialogVisible: false,
      editedPrivilegeId: undefined,
      errors: {},
      methodSearch: '',
      entitySearch: '',
      actionSearch: '',
      roleSearch: '',
      descriptionSearch: ''
    }
  },
  computed: {
    privileges () {
      let privileges = JSON.parse(JSON.stringify(this.$store.state.Privilege.privilege_list))
      // filter by method
      privileges = this.methodSearch === '' ? privileges : privileges.filter(privil => privil.method.toLowerCase().indexOf(this.methodSearch.toLowerCase()) > -1)
      // filter by entity
      privileges = this.entitySearch === '' ? privileges : privileges.filter(privil => privil.entity.toLowerCase().indexOf(this.entitySearch.toLowerCase()) > -1)
      // filter by action
      privileges = this.actionSearch === '' ? privileges : privileges.filter(privil => privil.action.toLowerCase().indexOf(this.actionSearch.toLowerCase()) > -1)
      // filter by role
      privileges = this.roleSearch === '' ? privileges : privileges.filter(privil => privil.Roles.find(role => role.name.toLowerCase().indexOf(this.roleSearch.toLowerCase()) > -1))
      // filter by description
      privileges = this.descriptionSearch === '' ? privileges : privileges.filter(privil => privil.description.toLowerCase().indexOf(this.descriptionSearch.toLowerCase()) > -1)
      return privileges.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
    }
  },
  methods: {
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (this.side === 'left') {
        this.$store.dispatch('Privilege/addPrivilegesSelectedLeft', val)
      }
      if (this.side === 'right') {
        this.$store.dispatch('Privilege/addPrivilegesSelectedRight', val)
      }
    },
    handleAdd () {
      this.editedPrivilegeId = 0
      this.editDialogVisible = true
    },
    handleEdit (row) {
      this.editedPrivilegeId = row.id
      this.editDialogVisible = true
    },
    handleDelete (row) {
      console.log(row)
    },
    handleCloseEditDialog (result) {
      this.editedPrivilegeId = null
      this.editDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.row {
  display: flex;
  font-size: $--font-size-base;
  padding: 10px 0px;
  &.header {
    color: $--color-text-secondary;
  }
  .cell {
    width: calc((100% - 55px)/5);
    border-bottom: $--border-light;
    // border: 1px dotted pink;
    &.header {
      display: flex;
      align-items: center;
      justify-content: left;
      border-bottom: 2px solid $--color-primary;
      margin-bottom: 15px;
      padding-bottom: 15px;
      .name {
        margin-right: 15px;
      }
      .input {
        max-width: 100px;
      }
    }
    &.buttons {
      text-align: right;
      width: 55px;
    }
    &.client {
      .row-inner {
        color: $--color-text-secondary;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Privilege/List.vue